import { useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useGlobalLoader, incrementLoader, decrementLoader } from '@/context/GlobalLoaderContext';

export function GlobalLoader() {
  const { isLoading } = useGlobalLoader();
  const { pathname } = useLocation();
  const prevPathname = useRef(pathname);

  useEffect(() => {
    if (pathname === prevPathname.current) return;
    prevPathname.current = pathname;

    incrementLoader();
    let done = false;
    const timer = setTimeout(() => {
      done = true;
      decrementLoader();
    }, 400);

    return () => {
      clearTimeout(timer);
      if (!done) decrementLoader();
    };
  }, [pathname]);

  return (
    <>
      <style>{`
        @keyframes loader-slide {
          0%   { transform: translateX(-100%); }
          50%  { transform: translateX(300%); }
          100% { transform: translateX(-100%); }
        }
      `}</style>
      <div
        aria-hidden="true"
        style={{ pointerEvents: 'none' }}
        className={`fixed top-0 left-0 right-0 h-[3px] z-[9999] overflow-hidden transition-opacity duration-300 ${
          isLoading ? 'opacity-100' : 'opacity-0'
        }`}
      >
        <div
          className="absolute top-0 left-0 h-full w-1/3 bg-blue-500"
          style={{ animation: 'loader-slide 1.4s ease-in-out infinite' }}
        />
      </div>
    </>
  );
}
